export const TAX_PERCENTAGE = 7.5;